import useQuery from "../search/useQuery";
import QUERY_TAGS from "../search/queryTags";
import { DETAIL_STALE_TIME } from "../finance/financeCache";
import { fetchProduct, fetchSupplierDetail } from "../detail/detailService";
import { asTargetId, normalizeTargetType, targetTypeLabel, TARGET_TYPES } from "./reviewsMappers";

const useReviewTarget = ({ targetType, targetId, fallbackName } = {}) => {
  const type = normalizeTargetType(targetType);
  const id = asTargetId(targetId);
  const isProduct = type === TARGET_TYPES.PRODUCT;

  const supplier = useQuery({
    key: id && !isProduct ? `supplier:${id}` : null,
    tag: QUERY_TAGS.SUPPLIER_DETAIL,
    staleTime: DETAIL_STALE_TIME,
    enabled: Boolean(id) && !isProduct,
    fetcher: () => fetchSupplierDetail(id),
  });

  const product = useQuery({
    key: id && isProduct ? `product:${id}` : null,
    tag: QUERY_TAGS.PRODUCT_DETAIL,
    staleTime: DETAIL_STALE_TIME,
    enabled: Boolean(id) && isProduct,
    fetcher: () => fetchProduct(id),
  });

  const query = isProduct ? product : supplier;
  const dto = query.currentData;

  const imageUrl = isProduct ? dto?.imageUrls?.[0] || null : dto?.referenceUrlLogo || null;

  return {
    name: dto?.name || fallbackName || "",
    imageUrl,
    subtitle: targetTypeLabel(type),
    isLoading: query.enabled && dto === undefined && !query.isError,
  };
};

export default useReviewTarget;
